import { render, staticRenderFns } from "./IconSuv.vue?vue&type=template&id=18c03254"
import script from "./IconSuv.vue?vue&type=script&lang=js"
export * from "./IconSuv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports